import { render } from "./SlideshowTemplate.vue?vue&type=template&id=006efd10&scoped=true"
import script from "./SlideshowTemplate.vue?vue&type=script&lang=js"
export * from "./SlideshowTemplate.vue?vue&type=script&lang=js"

import "./SlideshowTemplate.vue?vue&type=style&index=0&id=006efd10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006efd10"]])

export default __exports__